'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import { companiesFeedbackImages } from 'src/constants'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useMessages, useTranslations } from 'use-intl'
const Slider = dynamic(() => import('react-slick'), { ssr: false })

const CompaniesFeedbacksSlider = () => {
  const t = useTranslations('clients-page.slider-section')
  const messages = useMessages()
  const sliders = Object.keys(messages['clients-page']['slider-section'])
//   const sliderSettings = getSlickSettings(sliders?.length, 'default')
     const sliderSettings = {
          'slidesToShow': 4, 'slidesToScroll': 1, 'focusOnSelect': false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        };
  return (
    <section className='pt-24 py-12'>
      <div className='container companies-feedbacks-slider'>
        <div className='ml-[15px] mt-5 mb-10'>
        <Image
className='h-auto'
width={45}
height={45}
src='https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/icon-quote.png'
alt='Rolzo Clients Feedback'
/> 
        </div>
        <Slider {...sliderSettings}>
          {sliders?.map((item, index) => (
            <div key={item} className=" bg-[#FBFBFB] text-[18px] md:text-[14px] h-[455px] md:h-[400px]  leading-[1.6] flex flex-col font-light items-center  px-6 py-[30px] ">
                <div className='mb-[30px]'>
                    <Image
className='h-auto'
width={100}
height={67}
src={companiesFeedbackImages[t(`${item}.company`)] || 'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_1_Amex.png'}
alt='Clients feedback working with ROLZO'
/>
                </div>
                <p className='mb-9'>{t(`${item}.quote`)}</p>
                <p >{t(`${item}.author`)}</p>
          </div>
          ))}
        </Slider>
      </div>
    </section>
  )
}

export default CompaniesFeedbacksSlider
